import React, { useEffect, useState } from 'react';
import { ItemSelectDropdown } from '@ps-design-system/components/ItemSelectDropdown';
import PropTypes from 'prop-types';
import { Text } from '@ps-design-system/components/Text';

const SpaceSelectDropdown = (props) => {
  const {
    spaces,
    selectedSpaceId,
    onSpaceSelected
  } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const selectedSpaceIndex = spaces.findIndex(space => space._id === selectedSpaceId);

    if (-1 < selectedSpaceIndex) {
      setSelectedIndex(selectedSpaceIndex);
      onSpaceSelected(spaces[selectedSpaceIndex]._id);
    }
  }, []);

  const handleSelect = (index) => {
    setSelectedIndex(index);
    onSpaceSelected(spaces[index]._id);
  };

  return (
    <div className="ItemSelectDropdownContainer">
      <ItemSelectDropdown
        selectedIndex={selectedIndex}
        onSelect={handleSelect}
      >
        {spaces.map((space, index) => (
          <ItemSelectDropdown.Item key={index}>
            <div className="ItemSelectDropdownContainer_item-container">
              <Text
                typeface="body-2-m"
                className="ItemSelectDropdownContainer_item-title">
                {space.title}
              </Text>
              <Text typeface="body-1" className="text-gray-600">{space.street}</Text>
            </div>
          </ItemSelectDropdown.Item>
        ))}
      </ItemSelectDropdown>
    </div>
  );
};

SpaceSelectDropdown.propTypes = {
  spaces: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    street: PropTypes.string
  })).isRequired,
  onSpaceSelected: PropTypes.func,
  selectedSpaceId: PropTypes.string
};

export default SpaceSelectDropdown;
